import React, { Component } from 'react';
import Moment from 'react-moment';

class RatedReviewDetail extends Component{
    componentDidMount() {
        if(!this.props.location.state)
            this.props.history.replace({ pathname: process.env.PUBLIC_URL+'/reviews/rated/'});
        window.scrollTo(0, 0)
    }

    render() {
        let stars = []
        if(this.props.location.state) {
            for (var i = 0; i < this.props.location.state.deal.rate; i++)
                stars.push(<span key={this.props.location.state.deal._id + '_' + i}
                                 className="fa fa-star checked"></span>)
            for (i = this.props.location.state.deal.rate; i < 5; i++)
                stars.push(<span key={this.props.location.state.deal._id + '_' + i} className="fa fa-star"></span>)
        }
        return (
            this.props.location.state ?
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 px--xs-0">
                            <div className="all-categories-outer feedback-wrapper">
                                <div className="each-category-outer">
                                    <div className="row">
                                        <div className="col-lg-4 col-xl-3 spacing-all-category">
                                            <div className="category-box-outer p-0 border-grey">
                                                <div className="category-box-header h-md">
                                                    <img src={this.props.location.state.deal.image} alt={this.props.location.state.deal.name}/>
                                                </div>
                                                <div className="category-box-body">
                                                    <h1 className="date-01"><span><Moment format="DD" parse="DD-MM-YYYY">
                                                        {this.props.location.state.deal.purchased_for_date ? this.props.location.state.deal.purchased_for_date : this.props.location.state.deal.dealdate}
                                                    </Moment></span><span> <Moment format="MMM" parse="DD-MM-YYYY">
                                                        {this.props.location.state.deal.purchased_for_date ? this.props.location.state.deal.purchased_for_date : this.props.location.state.deal.dealdate}
                                                    </Moment></span></h1>
                                                    <div className="deal_rating_sec">
                                                        <h4 className="category-box-body-title custom-height">{this.props.location.state.deal.category.name}</h4>
                                                        <p className="category-box-body-subtitle custom-height">{this.props.location.state.deal.name}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-xl-9 mx-auto">
                                            <div className="feedbackform-outer">
                                                <div className="allstar-outer ratedstar">
                                                    <h6 className="text-white mr-1 mb-0">Rated the deal -</h6>{stars}
                                                </div>
                                                {this.props.location.state.deal.feedback &&
                                                <div className="ratingrow-outer">
                                                    <h6 className="green-color">Your Feedback</h6>
                                                    <p>{this.props.location.state.deal.feedback}</p>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                : null
        )
    }
}

export default RatedReviewDetail;